<footer class="footer-shell">
    <div class="footer-content">
        <p class="brand-text">WebLab © 2025</p>
        <p class="meta-text">Obsidian Edition v1.0</p>
    </div>
</footer>

<style>
    .footer-shell {
        background-color: var(--surface-container);
        border-top: 1px solid var(--line);
        padding: var(--spacing-xl) var(--spacing-lg);
        width: 100%;
    }

    .footer-content {
        max-width: 1280px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: var(--spacing-md);
    }

    .brand-text {
        color: var(--text);
        font-weight: 600;
        font-size: 14px;
        letter-spacing: -0.01em;
        margin: 0;
    }

    .meta-text {
        color: var(--muted);
        font-family: var(--font-mono);
        font-size: 12px;
        font-weight: 500;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        margin: 0;
    }

    @media (max-width: 900px) {
        .footer-shell {
            padding: var(--spacing-lg) var(--spacing-md);
        }

        .footer-content {
            flex-direction: column;
            align-items: flex-start;
            gap: var(--spacing-sm);
        }
    }
</style>

